var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "w-responsive mx-auto vh-0" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "min-vh-100 border",
        staticStyle: { background: "#F7F7F7" },
      },
      [_c("router-view")],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "w-100 p-1 header",
        staticStyle: { background: "#04488e", height: "100%" },
      },
      [
        _c(
          "h5",
          {
            staticClass: "align-baseline",
            staticStyle: { color: "white", "font-size": "13px" },
          },
          [
            _c("i", { staticClass: "fa fa-user-clock fa-2x" }),
            _vm._v("  Reserva "),
            _c("strong", [_vm._v("Online")]),
            _vm._v(" de "),
            _c("strong", [_vm._v("Horas Médicas")]),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }